import React, { useContext } from "react";
import CoverPic from "./CoverPic";
import Box from "@material-ui/core/Box";
import SocialStats from "./SocialStats";
import FollowingInfo from "./FollowingInfo";
import { useSelector } from "react-redux";
import PerfectScrollbar from "react-perfect-scrollbar";
import { getWallHeight } from "../../../../@jumbo/constants/AppConstants";
import makeStyles from "@material-ui/core/styles/makeStyles";
import AppContext from "../../../../@jumbo/components/contextProvider/AppContextProvider/AppContext";
import { user } from "@fake-db/apps/wall";
import Biography from "./Biography";

const useStyles = makeStyles(() => ({
  perfectScrollbarGerneralInfo: {
    height: props => `calc(100vh - ${props.height}px)`
  }
}));

const GeneralInfo = width => {
  const userProfileData = useSelector(
    state => state.usersModule.userProfileData
  );

  const { showFooter } = useContext(AppContext);
  const userDetail = user;
  const classes = useStyles({
    height: getWallHeight(width, showFooter)
  });

  return (
    <PerfectScrollbar className={classes.perfectScrollbarGerneralInfo}>
      {userDetail && (
        <Box>
          <Box mb={11}>
            <CoverPic
              userDetail={userProfileData}
              cover_pic={userDetail?.cover_profile_url}
            />
          </Box>
          <Box mb={5}>
            <SocialStats userDetail={userProfileData} />
          </Box>
          <Box mb={5}>
            <FollowingInfo userDetail={userProfileData} />
          </Box>
          <Box mb={5}>
            <Biography userDetail={userProfileData} />
          </Box>
        </Box>
      )}
    </PerfectScrollbar>
  );
};

export default GeneralInfo;
